/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLoader3 = createReactComponent("loader-3", "IconLoader3", [
  [
    "path",
    { d: "M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9", key: "svg-0" }
  ],
  ["path", { d: "M17 12a5 5 0 1 0 -5 5", key: "svg-1" }]
]);

export { IconLoader3 as default };
//# sourceMappingURL=IconLoader3.js.map
